import React, { Component } from 'react';

import { connect } from 'react-redux';
import * as uuid from 'uuid';
import Multi from '../../components/Multi';
import Whitebox from '../../components/WhiteBox';
import BorderButton from '../../components/BorderButton';
import { FileInput } from './file-input';
import UploadModal from './upload-modal';
import GDPR from '../../components/GDPR';
import Select from 'react-select';
import axios from 'axios';
import debounce from 'lodash/debounce';
import Big from 'big.js';
import { Auth, Storage } from 'aws-amplify';
import config from '../../config';
import { aws_config } from '../../aws_config';
import SessionService from '../../lib/services/SessionService';
import { cookieTypes as cookieTypesValues } from '../../lib/cookie_types';
import Amplify from 'aws-amplify';
import ReactTooltip from 'react-tooltip';

/**
 * Generic form for uploads: single, bulk and opt out types
 */
class ImportAudienceFormBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadType: 'single',
      saving: false,
      audienceName: '',
      description: '',
      branded: true,
      audienceId: '',
      cookie: '',
      uid: '',
      csvFile: '',
      uploadSuccess: false,
      toggleUpload: false,
      uploadNotificationData: null,
      exampleUpload: '12333454334553\n123123213123234\n43356434555435\n...',
      exampleUploadBulk:
        'USER_ID1, AUDIENCE_ID1, AUDIENCE_ID2\nUSER_ID2, AUDIENCE_ID2\nAUDIENCE_IDX, ...',
      editMode: true,
      displayUploadModal: false,
      importBtn: false,
      offset: 0,
      size: 10,
      audience_search: '',
      audience_search_results: [],
      uploadStatus: {},
      cookieTypes: ['adform', 'ar', 'ip', 'mobile'],
      region: 'US',
    };

    this.debouncedSearchFunction = null;
  }

  componentDidMount() {
    console.log('mount ', this.props);

    if (this.props.uploadType && this.props.uploadType != '') {
      this.setState({ uploadType: this.props.uploadType });
      if (this.props.uploadType === 'bulk') {
        this.setState({ exampleUpload: this.state.exampleUploadBulk });
      }
    }
    if (this.props.audienceName && this.props.audienceName != '') {
      this.setState({ audienceName: this.props.audienceName });
    }
    console.log('init audid', this.props.audienceId);
    if (this.props.audienceId && this.props.audienceId != '') {
      this.setState({ audienceId: this.props.audienceId, editMode: false });
    }
    if (this.props.description && this.props.description != '') {
      this.setState({ description: this.props.description });
    }
    if (
      this.props.importBtn != null &&
      this.props.importBtn != undefined &&
      this.props.importBtn
    ) {
      this.setState({ importBtn: this.props.importBtn, toggleUpload: true });
    }

    // new import without passing an audience
    if (!this.props.audienceId || this.props.audienceId == '') {
      this.loadAudiences();
    }

    this.debouncedSearchFunction = debounce(this.loadAudiences, 500);

    // handle cookie types filter based on partner logged
    let cookieTypes = cookieTypesValues;

    let partnerLogged = SessionService.getPartnerLogged();
    if (partnerLogged != null) {
      if (partnerLogged && partnerLogged.hasOwnProperty('cookieTypes')) {
        cookieTypes = partnerLogged.cookieTypes.split(',');
      }
    }
    this.setState({ cookieTypes: cookieTypes });
  }

  fileSelected(file) {
    console.log('pre select file ' + this.state.csvFile);
    this.setState(
      {
        csvFile: file,
        uid: uuid(),
      },
      () => {
        console.log('post select file ' + this.state.csvFile);
      }
    );
  }

  checkSaveButtonValid() {
    console.log('checkSaveButtonValid toggleUpload ' + this.state.toggleUpload);
    console.log(
      'checkSaveButtonValid csvFile ',
      this.state.csvFile,
      this.state.csvFile == ''
    );
    console.log('checkSaveButtonValid cookie ' + this.state.cookie);
    if (!this.state.toggleUpload) return false;

    let ret =
      this.state.cookie != '' &&
      this.state.csvFile != '' &&
      this.state.csvFile != undefined;
    console.log('checkSaveButtonValid ret ' + ret);
    return !ret;
  }

  upload() {
    this.setState({ saving: true, displayUploadModal: true }, () => {
      this.uploadAudiencesToS3(
        this.state.cookie,
        this.state.uid,
        this.state.csvFile,
        this.state.audienceId
      );
    });
  }

  uploadAudiencesToS3(cookie, uid, file, dispatch, getState, audienceId) {
    let self = this;

    let partnerId = '';

    let partnerLogged = SessionService.getPartnerLogged();

    // use masquerading partner id or the logged partner id
    if (partnerLogged != null) {
      partnerId = partnerLogged.partnerId;
    }

    const folder = `partner=${partnerId}/cookie=${cookie}/id=${uid}`;
    const start = Date.now();
    let lastStep = new Big(0);

    let s3KeyPrefixUploaded = '';
    this.setState({ displayUploadModal: true }, () => {
      // amplify s3 upload

      // re-configure storage for EU or US upload type. without the correct region we cannot upload
      if (this.state.region === 'EU') {
        aws_config.Storage.AWSS3.region = config.awsRegionEU;
        aws_config.Storage.AWSS3.bucket = config.audienceBucketEU;
      } else {
        aws_config.Storage.AWSS3.region = config.awsRegion;
        aws_config.Storage.AWSS3.bucket = config.audienceBucket;
      }

      //aws_config.Storage.AWSS3.region = 'eu-west-1'
      Amplify.configure(aws_config);

      Storage.put(`${folder}/${file.name}`, file, {
        // here you can set a custom prefix
        customPrefix: {
          private: 'poolid=',
        },
        partSize: 5 * 1024 * 1024,
        queueSize: 4,
        contentType: file.type,
        progressCallback(evt) {
          console.log('progressCallback ', evt);
          s3KeyPrefixUploaded = evt.key;

          const progress = new Big(evt.loaded).div(evt.total);
          const step = progress.times(100).round(0, 0);

          const now = Date.now();
          if (now > start && step.gt(lastStep)) {
            lastStep = step;
            const elapsed = new Big(now - start);
            const total = elapsed.div(progress);
            const remaining = total.minus(elapsed);

            // set progress state
            self.setState({
              uploadStatus: {
                uploading: true,
                progress: step.toFixed(0),
                eta: remaining
                  .div(1000)
                  .round(0, 0)
                  .toFixed(0),
                elapsed: elapsed
                  .div(1000)
                  .round(0, 0)
                  .toFixed(0),
              },
            });
          }
        },
      })
        .then((data) => {
          console.log('calling upload notification', data);

          // upload complete
          self.setState({
            uploadStatus: {
              uploading: false,
              checked: true,
              valid: true,
            },
          });

          //
          // then send upload notification
          let fileurl =
            's3://' +
            aws_config.Storage.AWSS3.bucket +
            '/' +
            decodeURIComponent(s3KeyPrefixUploaded);
          let notificationData = {
            audienceId: audienceId,
            cookieType: cookie,
            fileList: [fileurl],
          };
          console.log('notification data ', notificationData);

          // return this notificationData
          self.setState({ uploadNotificationData: notificationData });
        })
        .catch((err) => {
          console.log(err);

          // upload complete with errors
          self.setState({
            uploadStatus: {
              uploading: false,
              checked: true,
              valid: false,
              uploadError: err,
            },
          });
        });
    });
  }

  onSave() {
    console.log('on save ', this.state.csvFile, this.state.cookie);
    if (
      this.state.csvFile !== null &&
      this.state.csvFile !== '' &&
      this.state.cookie !== ''
    ) {
      this.upload();
    } else {
      this.setState({ saving: true }, () => {
        this.props.save(this.state);
      });
    }
  }

  onChangeCookieType(cookieType) {
    this.setState({ cookie: cookieType });

    if (this.state.uploadType === 'single') {
      // change example
      if (cookieType === 'ip') {
        this.setState({ exampleUpload: '256.11.22.33\n256.11.22.44\n....' });
      } else {
        this.setState({
          exampleUpload: '12333454334553\n123123213123234\n43356434555435\n...',
        });
      }
    } else if (this.state.uploadType === 'bulk') {
      if (cookieType === 'ip') {
        this.setState({
          exampleUpload:
            '256.11.22.33, AUDIENCE_ID1, AUDIENCE_ID2\n256.11.22.44, AUDIENCE_ID2\n....',
        });
      } else {
        this.setState({
          exampleUpload:
            'USER_ID1, AUDIENCE_ID1, AUDIENCE_ID2\nUSER_ID2, AUDIENCE_ID2\nAUDIENCE_IDX, ...',
        });
      }
    }
  }

  loadAudiences = (inputValue) => {
    console.log('loadAudiences ', inputValue);
    //new Promise(resolve => {
    axios
      .get(
        '/audience?offset=' +
          this.state.offset +
          '&size=' +
          this.state.size +
          '&filter=' +
          this.state.audience_search +
          '&sort=creation&sortOrder=desc&showDeleted=false'
      )
      .then((response) => {
        let audiences = response.data.body;
        console.log('audiences', audiences);
        //resolve(audiences);
        //resolve([{'audienceId': '1' , 'audienceName': 'b'} ]);
        //resolve(audiences.map( a => ({ value: a.audienceId, label: a.audienceName })) )
        //this.setState({audience_search_results: audiences.map(a => ({"value": a.audienceId, "label": a.audienceName}) ) })
        audiences = audiences.map((a) => ({
          audienceId: a.audienceId,
          audienceName: a.audienceName,
        }));
        this.setState({ audience_search_results: audiences });
        return audiences;
      });
    //});
  };

  handleAudienceChange(value) {
    console.log('select change', value);
    if (value != undefined) {
      this.setState({ audience_search: value }, () => {
        this.debouncedSearchFunction();
      });
    }
  }

  handleAudienceSelect(selectedOption) {
    console.log('selectedOption', selectedOption);
    this.setState({ audienceId: selectedOption.audienceId });
  }

  onUploadModalConfirm() {
    this.setState({ displayUploadModal: false, saving: false }, () => {
      this.props.save(this.state);
    });
  }

  render() {
    return (
      <Multi>
        <UploadModal
          uploadStatus={this.state.uploadStatus}
          display={this.state.displayUploadModal}
          onConfirm={() => this.onUploadModalConfirm()}
        />
        <div className='row justify-content-center'>
          <div className='col-10'>
            <Whitebox>
              <div style={{ position: 'relative', paddingRight: 100 }}>
                <div className='row'>
                  <div className='col-3'>
                    <img
                      src='/img/audience/import-audience.png'
                      alt=''
                      style={{ maxWidth: '100%' }}
                    />
                  </div>
                  <div className='col-9'>
                    {this.state.uploadType === 'single' && (
                      <span>
                        <h3 style={{ marginTop: 26 }}>Import audience</h3>
                        <p style={{ fontSize: 'smaller', color: '#797979' }}>
                          Import segment file for an Audience based on DMP
                          cookie list export
                        </p>

                        {/* select audience from a list   */}
                        {this.props.audienceId && this.props.audienceId != '' && (
                          <div className='row'>
                            <div className='col-12'>
                              <p style={{ marginTop: 30 }}>
                                Audience final name
                              </p>
                              <input
                                type='text'
                                className='form-control'
                                readOnly={true}
                                value={this.state.audienceName}
                              />
                            </div>
                          </div>
                        )}
                        {(!this.props.audienceId ||
                          this.props.audienceId == '') && (
                          <div className='row'>
                            <div className='col-12'>
                              <label>Audience</label>
                              <Select
                                placeholder='Search an audience...'
                                options={this.state.audience_search_results}
                                onInputChange={this.handleAudienceChange.bind(
                                  this
                                )}
                                onChange={this.handleAudienceSelect.bind(this)}
                                getOptionLabel={(option) =>
                                  option['audienceName']
                                }
                                getOptionValue={(option) =>
                                  option['audienceId']
                                }
                              />
                            </div>
                          </div>
                        )}
                      </span>
                    )}
                    {this.state.uploadType === 'bulk' && (
                      <span>
                        <h3 style={{ marginTop: 26 }}>Bulk Upload</h3>
                        <p style={{ fontSize: 'smaller', color: '#797979' }}>
                          Bulk upload segments to existing audiences
                        </p>
                      </span>
                    )}

                    <div className='row ' style={{ marginTop: '20px' }}>
                      <div className='col-md-12'>
                        <div className='card'>
                          <div className='card-body'>
                            <h5 className='card-title'>Upload a file</h5>
                            <p className='card-text'>
                              {/**
                                                            <GDPR />
                                                            */}

                              <div className='row'>
                                <div className='col-md-12'>
                                  <p
                                    style={{
                                      fontSize: 'smaller',
                                      color: 'rgb(121, 121, 121)',
                                    }}
                                  >
                                    File will be a plain .csv file or a .gz file
                                    containing csv files, without header
                                    separated by \n'. &#160;
                                    <b
                                      style={{
                                        color: 'black',
                                        fonWeight: 'bold',
                                      }}
                                    >
                                      Maximum upload size is 1GB for plain csv
                                      files and 500MB for compressed files.
                                    </b>
                                  </p>
                                  <p
                                    style={{
                                      fontSize: 'smaller',
                                      color: 'rgb(121, 121, 121)',
                                    }}
                                  >
                                    For Example:
                                    <pre
                                      style={{
                                        'background-color': 'transparent',
                                        color: 'black',
                                      }}
                                    >
                                      <div
                                        className='alert alert-secondary'
                                        role='alert'
                                      >
                                        <code
                                          style={{
                                            'background-color': 'transparent',
                                            color: 'black',
                                          }}
                                        >
                                          {this.state.exampleUpload}
                                        </code>
                                      </div>
                                    </pre>
                                  </p>
                                </div>
                              </div>

                              <div className='row'>
                                <div className='col-md-3'>
                                  <p style={{ marginTop: 0 }}>
                                    Cookie Geography&#160;
                                    <ReactTooltip
                                      id={'infoDmpsSyncTooltip'}
                                      type='dark'
                                      effect='solid'
                                    >
                                      <div>
                                        Selecting a cookie locality ensure that
                                        your data is stored and processed in a
                                        compliant way of the GDPR.
                                      </div>
                                    </ReactTooltip>
                                    <span
                                      style={{
                                        'margin-right': '20px',
                                        'margin-top': '5px',
                                      }}
                                    >
                                      <i
                                        data-tip
                                        data-for='infoDmpsSyncTooltip'
                                        className='fa fa-2 fa-question-circle'
                                        style={{ color: 'black' }}
                                      ></i>
                                    </span>
                                  </p>

                                  <select
                                    className='form-control'
                                    value={this.state.region}
                                    onChange={({ target }) => {
                                      this.setState({ region: target.value });
                                    }}
                                  >
                                    <option value='US'>United States</option>
                                    <option value='EU'>Europe</option>
                                  </select>
                                </div>

                                <div className='col-md-3'>
                                  <p style={{ marginTop: 0 }}>Cookie Type</p>

                                  {(this.state.uploadType === 'single' ||
                                    this.state.uploadType === 'optout') && (
                                    <select
                                      className='form-control'
                                      value={this.state.cookie}
                                      onChange={({ target }) => {
                                        this.onChangeCookieType(target.value);
                                      }}
                                    >
                                      <option value=''>Please Choose...</option>
                                      {this.state.cookieTypes.indexOf(
                                        'adform'
                                      ) != -1 && (
                                        <option value='adform'>AdForm</option>
                                      )}
                                      {this.state.cookieTypes.indexOf(
                                        'mobile'
                                      ) != -1 && (
                                        <option value='mobile'>
                                          Mobile Id
                                        </option>
                                      )}
                                      {this.state.cookieTypes.indexOf('ip') !=
                                        -1 && (
                                        <option value='ip'>Ip Address</option>
                                      )}
                                      {this.state.cookieTypes.indexOf('ar') !=
                                        -1 && (
                                        <option value='ar'>Audiencerate</option>
                                      )}
                                      {this.state.cookieTypes.indexOf(
                                        'sirdata'
                                      ) != -1 && (
                                        <option value='sirdata'>Sirdata</option>
                                      )}
                                      {this.state.cookieTypes.indexOf(
                                        'weborama'
                                      ) != -1 && (
                                        <option value='weborama'>
                                          Weborama
                                        </option>
                                      )}
                                      {this.state.cookieTypes.indexOf('tdd') !=
                                        -1 && <option value='tdd'>TDD</option>}
                                      {this.state.cookieTypes.indexOf('ID5') !=
                                        -1 && <option value='ID5'>ID5</option>}
                                    </select>
                                  )}

                                  {this.state.uploadType === 'bulk' && (
                                    <select
                                      className='form-control'
                                      value={this.state.cookie}
                                      onChange={({ target }) => {
                                        this.onChangeCookieType(target.value);
                                      }}
                                    >
                                      <option value=''>Please Choose...</option>
                                      {this.state.cookieTypes.indexOf(
                                        'adform'
                                      ) != -1 && (
                                        <option value='adform'>
                                          AdForm or Mobile id
                                        </option>
                                      )}
                                      {this.state.cookieTypes.indexOf('ar') !=
                                        -1 && (
                                        <option value='ar'>
                                          Audiencerate or Mobile id
                                        </option>
                                      )}
                                      {this.state.cookieTypes.indexOf(
                                        'mobile'
                                      ) != -1 && (
                                        <option value='mobile'>
                                          Mobile Id
                                        </option>
                                      )}
                                      {this.state.cookieTypes.indexOf('ip') !=
                                        -1 && (
                                        <option value='ip'>Ip Address</option>
                                      )}
                                      {this.state.cookieTypes.indexOf(
                                        'sirdata'
                                      ) != -1 && (
                                        <option value='sirdata'>Sirdata</option>
                                      )}
                                      {this.state.cookieTypes.indexOf(
                                        'weborama'
                                      ) != -1 && (
                                        <option value='weborama'>
                                          Weborama
                                        </option>
                                      )}
                                      {this.state.cookieTypes.indexOf('tdd') !=
                                        -1 && <option value='tdd'>TDD</option>}
                                      {this.state.cookieTypes.indexOf('ID5') !=
                                        -1 && <option value='ID5'>ID5</option>}
                                    </select>
                                  )}

                                  {this.state.cookie == 'tdd' && (
                                    <span
                                      style={{
                                        'font-size': 'smaller',
                                        color: 'rgb(121, 121, 121)',
                                      }}
                                    >
                                      You can only use this single type and
                                      cannot mix it with mobile ids!
                                    </span>
                                  )}
                                </div>

                                <div className='col-md-6'>
                                  <p style={{ marginTop: 0 }}>CSV/GZ File</p>
                                  <div className='import-license csv-upload'>
                                    <FileInput
                                      fileSelected={(file) =>
                                        this.fileSelected(file)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='row col-12 alert alert-warning mt-4 ml-1 mb-0'>
                      Please consider to license an audience before uploading
                      some files, so that the IDs will be loaded on the
                      destination DMP.
                    </div>

                    <div className='new-segment-based-audience new-segment-based-audience--button-group'>
                      <BorderButton
                        className='grey'
                        label='Cancel'
                        onClick={() => this.props.cancel()}
                      />
                      <BorderButton
                        disabled={
                          this.checkSaveButtonValid() || this.state.saving
                        }
                        className='very-blue'
                        label='Import'
                        onClick={() => {
                          console.log('on click save ', this.state);
                          this.onSave();
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Whitebox>
          </div>
        </div>
      </Multi>
    );
  }
}

export const ImportAudienceForm = connect(
  (state) => ({}),
  {}
)(ImportAudienceFormBase);
